export default "__VITE_ASSET__g9n3aQcL__"